
export class ChartDTO {
  type: string;
  data: DataChart;
  options: OptionsChart;
}


export class DataChart {
  labels: string[];
  datasets: DataSet[];
}


export class DataSet {
  label: string;
  subLabel: string[];
  data: any[];
  backgroundColor: string[];
  borderColor: string[];
  borderWidth: number;
}


export class OptionsChart {
  title: titleChart;
}

export class titleChart {
  display: boolean;
  text: string;
}
